<template>
  <div class="v-container cay-gia-pha">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div v-else>
      <div class="header">
        <h4>
          Cây gia phả dòng họ
          <span class="header__name">{{ ten_dong_ho }}</span>
        </h4>
        <div class="header__action">
          <div class="header__input" ref="inputHints">
            <el-input
              placeholder="Nhập tên thành viên"
              prefix-icon="el-icon-search"
              clearable
              v-model="name_search"
              style="width: 300px"
              @input="getListSearch"
              @clear="clearInputSearch"
            >
            </el-input>
            <div
              class="header__input--hints"
              ref="listHints"
              v-show="is_show_hints"
            ></div>
          </div>
          <el-button type="primary" plain
            ><i class="fa-light fa-chevron-left"></i
            ><span class="text-button-span" @click="goBack"
              >Quay lại</span
            ></el-button
          >
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="tree"></div>
          <div class="zoom">
            <button>
              <i class="fa-light fa-plus" @click="zoomTree('in')"></i>
            </button>
            <button>
              <i class="fa-light fa-minus" @click="zoomTree('out')"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Circle4 } from "vue-loading-spinner";
import MethodService from "@/service/MethodService";
import mushroom from "viettoc-api";
import createTree from "vt-nodes";

export default {
  data() {
    return {
      loading: true,
      name_search: null,
      tree: null,
      ten_dong_ho: null,
      is_show_hints: false,
      zoom_percent: 100,
      zoom_level: 20,
    };
  },
  components: {
    Circle4,
  },

  methods: {
    zoomTree(type) {
      if (type === "in") this.zoom_percent += this.zoom_level;
      if (type === "out") this.zoom_percent -= this.zoom_level;
      this.tree.setZoom(this.zoom_percent);
    },

    goBack() {
      this.$router.push({
        name: "ChiTietDongHo",
      });
    },

    handleClickOutsideInputHints(event) {
      if (!this.$refs.inputHints) return;
      if (!this.$refs.inputHints.contains(event.target)) {
        this.is_show_hints = false;
      }
    },

    clearInputSearch() {
      this.name_search = null;
      this.is_show_hints = false;
    },

    getListSearch() {
      const nodes = this.tree.search(this.name_search, { limit: 20 });
      const searchHint = this.$refs.listHints;
      this.is_show_hints = true;

      if (nodes.length) {
        searchHint.innerHTML = nodes
          .map(
            (n) =>
              `<a data-node-id="${
                n.id
              }" class="node-hint">${MethodService.encodeHtml(
                n.ten.ho_ten
              )}</a>`
          )
          .join("");

        searchHint.querySelectorAll(".node-hint").forEach((a) => {
          a.onclick = () => {
            this.tree.flyToNode(a.getAttribute("data-node-id"));
          };
        });
      } else if (!this.name_search) {
        searchHint.innerHTML = "";
      } else {
        searchHint.innerHTML =
          '<div class="empty-search-result">Không tìm thấy tên phù hợp</div>';
      }
    },

    async getTenDongHo() {
      try {
        const response = await mushroom.dong_ho.findByIdAsync({
          id: this.$router.currentRoute.params.id,
          fields: "id,ten",
        });
        if (response.result) this.ten_dong_ho = response.result.ten || "";
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    async getInfoForRenderCayGiaPha() {
      try {
        const response = await mushroom.node_gia_pha.cayGiaPhaAsync({
          body: {
            dong_ho_id: this.$router.currentRoute.params.id,
          },
        });
        if (!response.result) return;
        setTimeout(() => {
          this.tree = createTree(
            document.querySelector(".tree"),
            response.result
          );
          this.tree.renderTree();
        }, 500);
      } catch (e) {
        MethodService.showError(e.code);
      } finally {
        this.loading = false;
      }
    },
  },

  async mounted() {
    await this.getTenDongHo();
    await this.getInfoForRenderCayGiaPha();
    document.addEventListener("click", this.handleClickOutsideInputHints);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutsideInputHints);
  },
};
</script>
